import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const GuideRouterWrapper = () => {
  const { isAuthenticated, loadingAuth } = useAuth();

  // Wait for auth check to finish before redirecting
  if (loadingAuth) {
    return null; // Or a small loading spinner
  }

  // Redirect to the specific path defined in App.js
  // that is already wrapped in the appropriate Layout
  return isAuthenticated ? (
    <Navigate to="/dashboard/guide" replace />
  ) : (
    <Navigate to="/public/guide" replace />
  );
};

export default GuideRouterWrapper;
